import { Component, OnInit } from '@angular/core';
import { MyRemaxModes, ViewModes, LoginSource } from '../../classes/enums';
import { CommunicationService } from './../../services/communication.service';
import { Router } from '@angular/router';
import { HasSubscriptions } from './../has-subscriptions';
import { SavedSearch } from '../../classes/saved-search';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '../../services/preferences.service';
import { BreadCrumb } from '../bread-crumbs/bread-crumbs.component';
import { PreRenderService } from '../../services/pre-render.service';
import {ConfirmationService} from '../../services/confirmation/confirmation.service';
import { CredentialsService } from '../../services/credentials.service';
import { MANAGE_NOTIFICATION_PATH } from '../../app-config.constants';
import { takeWhile } from 'rxjs/operators';
import { UserService } from '../../services/user.service';


@Component({
  selector: 'app-my-remax',
  templateUrl: './my-remax.component.html',
  styleUrls: ['./my-remax.component.scss', './my-remax.desktop.component.scss']
})
export class MyRemaxComponent extends HasSubscriptions implements OnInit {

  myRemaxMode: MyRemaxModes;
  savedSearches: SavedSearch[] = [];
  showShare: boolean = false;
  isAuthenticated: boolean = false;
  breadcrumbs: BreadCrumb[] = [];
  showChangesSaved: boolean = false;

  // enums:
  MyRemaxModes = MyRemaxModes;

  favouriteAgentUrl: string;

  constructor(
    private router: Router,
    private communicationService: CommunicationService,
    private _preferencesService: PreferencesService,
    private activatedRoute: ActivatedRoute,
    private credentialsService: CredentialsService,
    private prerenderService: PreRenderService,
    private translationService: TranslateService,
    private confirmationService: ConfirmationService
  ) {
    super();
  }

  ngOnInit() {
    this.prerenderService.setPreRenderFlag(200);
    if (this.router.url === MANAGE_NOTIFICATION_PATH) {
      this.myRemaxMode = MyRemaxModes.MANAGE_NOTIFICATIONS;
      this.checkLogin();
    }
    this.addSub(this.activatedRoute.queryParamMap.subscribe((paramsMap) => {
      switch (paramsMap.get('mode')) {
        case MyRemaxModes.SAVED_SEARCHES: {
          this.myRemaxMode = MyRemaxModes.SAVED_SEARCHES;
          break;
        }
        default: {
          this.myRemaxMode = MyRemaxModes.FAVOURITES;
        }
      }
      this._updateBreadcrumbs();
    }));

    this.addSub(this._preferencesService.savedSearchesChanged.subscribe((savedSearches: SavedSearch[]) => {
      this.savedSearches = savedSearches;
    }));
  }

  checkLogin() {
    this.addSub(this.credentialsService.isLoggedIn.subscribe((isAuthenticated: boolean) => {
      const popup = !isAuthenticated && this.myRemaxMode === MyRemaxModes.MANAGE_NOTIFICATIONS ? { popup: [ 'register-login', LoginSource.Generic ] } : {};
      this.openRegisterLogin(popup);
    }));
  }

  openRegisterLogin(popup) {
    this.router.navigate(['/', { outlets: popup } ])
      .then(() => {
        this.showSavedSearches();
      });
  }

  showFavourites() {
    this.myRemaxMode = MyRemaxModes.FAVOURITES;
    this.communicationService.activeMyRemaxMode.next(this.myRemaxMode);
    this._updateBreadcrumbs();
  }

  showSavedSearches() {
    this.myRemaxMode = MyRemaxModes.SAVED_SEARCHES;
    this._updateBreadcrumbs();
  }

  startSavedSearch() {
    this.router.navigate(['/find-real-estate']);
  }

  deleteAllSavedSearches() {
    if (this.confirmationService.showConfirmation(this.translationService.instant('my-remax.saved-searches.confirm-all-delete'))) this._preferencesService.deleteAllSavedSearches();
  }

  deleteSavedSearch(s: SavedSearch) {
    if (this.confirmationService.showConfirmation(this.translationService.instant('my-remax.saved-searches.confirm-single-delete'))) this._preferencesService.deleteSavedSearch(s);
  }

  updateNotificationEnabledOnSavedSearches(savedSearches: SavedSearch[]) {
    let saveSearchUpdated = false;

    this.addSub(this.credentialsService.isLoggedIn
      .pipe(takeWhile(() => saveSearchUpdated === false ))
      .subscribe((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          this.updateSavedSearches(savedSearches);
          this.showChangesSaved = true;
          saveSearchUpdated = true;
        }
        else if (!isAuthenticated) {
          this.updateSavedSearches(savedSearches);
          saveSearchUpdated = true;
          this.router.navigate( ['/', { outlets: { popup: [ 'register-login', LoginSource.Radar ] } }]);
        }
      }
    ))

  }

  updateSavedSearches(savedSearches: SavedSearch[]) {
    savedSearches.forEach(ss => {
      this._preferencesService.updateNotificationOnSavedSearch(ss);
    });
  }

  restoreSavedSearch(s: SavedSearch) {
    // TODO: works for some reason with the timeout, find out why
    setTimeout(() => {
      this.communicationService.notifications.bottomNotification.next(this.translationService.instant('actions.restore-saved-search', {x: s.name}));
    }, 0);
    this._preferencesService.restoreSavedSearch(s);
    this.communicationService.selectedSaveSearch.next(s);
    this.router.navigate(['/find-real-estate']);
  }

  async home() {
    await this.router.navigate(['/find-real-estate']);
  }

  private _updateBreadcrumbs() {
    this.communicationService.activeMyRemaxMode.next(this.myRemaxMode);
    this.breadcrumbs = [
      {
        key: 'breadcrumbs.listing',
        url: '/find-real-estate',
        queryParams: null,
        isActive: true
      },
    ];
    if (this.myRemaxMode === MyRemaxModes.SAVED_SEARCHES) {
      this.breadcrumbs.push({
        key: 'breadcrumbs.saved-search',
        url: '/my-remax',
        queryParams: {
          mode: 'saved-searches'
        },
        isActive: true
      });
    }
    else if (this.myRemaxMode === MyRemaxModes.FAVOURITES) {
      this.breadcrumbs.push({
        key: 'breadcrumbs.saved-listings',
        url: '/my-remax',
        queryParams: {
          mode: 'favourites'
        },
        isActive: true
      })
    }
  }
}
